import { File } from 'lucide-react';
import { NodeShell } from './NodeShell.tsx';
import { colors } from '../../../config/design-tokens.ts';
import type { PKGNodeComponentProps } from './DecisionNode.tsx';

export function ArtefactNode({ data, isConnectable }: PKGNodeComponentProps) {
  return (
    <NodeShell
      testId="pkg-node-artefact"
      shape="square-outline"
      accentColor={colors.graphite[600]}
      icon={File}
      label={data.summary ?? data.entityId}
      badge={data.badge}
      outlineOnly
      isConnectable={isConnectable}
    />
  );
}
